import { render, staticRenderFns } from "./upload1.vue?vue&type=template&id=f3c4b258&scoped=true"
import script from "./upload1.vue?vue&type=script&lang=js"
export * from "./upload1.vue?vue&type=script&lang=js"
import style0 from "./upload1.vue?vue&type=style&index=0&id=f3c4b258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4b258",
  null
  
)

export default component.exports